import { ChangeDetectionStrategy,Component } from '@angular/core';

@Component({
    templateUrl: './root-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./root-page.component.scss'],
})
export class RootPageComponent {
}
